import script from "./RadioHours.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioHours.vue?vue&type=script&setup=true&lang=js"

import "./RadioHours.vue?vue&type=style&index=0&id=19cddc96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19cddc96"]])

export default __exports__